import React, { useRef } from "react";
import { TextField, InputAdornment, IconButton, Box } from "@mui/material";
import { Search as SearchIcon, Close as CloseIcon } from "@mui/icons-material";

export default function SearchField(props) {
  const searchIconOutside = !!props.searchIconOutside;
  const prevValueRef = useRef("");

  const commonTextField = (
    <TextField
      label={props?.label}
      variant="outlined"
      autoComplete="off"
      value={props.value}
      onChange={(e) => {
        let inputValue = e.target.value;
        const cleanedValue = inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");

        // If user cleared the field manually (backspace / delete all text),
        // trigger the same empty search as the clear (X) icon
        const prev = prevValueRef.current || "";
        if (cleanedValue === "" && prev.length > 0 && typeof props.onClear === "function") {
          props.onClear();
        }
        prevValueRef.current = cleanedValue;

        if (cleanedValue !== props.value) {
          props.onChange(cleanedValue);
        }
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter" && props.onSubmit) {
          const val = (props.value || "").trim();
          if (val) {
            props.onSubmit(e?.target?.value);
          }
        }
      }}
      placeholder={props.placeholder}
      color="primary"
      fullWidth={!searchIconOutside}
      size={props?.size}
      sx={searchIconOutside ? { flex: 1, ...(props?.sx || {}) } : (props?.sx || {})}
      onFocus={() => (props?.isFocused ? props?.isFocused() : null)}
      slotProps={{
        input: {
          startAdornment: searchIconOutside ? null : (
            <InputAdornment position="start">
              <IconButton
                size="small"
                edge="start"
                onClick={() => {
                  const val = (props.value || "").trim();
                  if (val && props.onSubmit) {
                    props.onSubmit(props.value);
                  }
                }}
                disabled={!((props.value || "").trim())}
                sx={{ p: 0, color: "action.active" }}
              >
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
          endAdornment:
            props.value !== "" ? (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  onClick={() => {
                    if (typeof props.onClear === "function") {
                      props.onClear();
                    } else {
                      props.onChange("");
                    }
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </InputAdornment>
            ) : null
        }
      }}
    />
  );

  if (searchIconOutside) {
    return (
      <Box sx={{ display: "flex", alignItems: "stretch", gap: 0.75, width: "100%" }}>
        {commonTextField}
        <IconButton
          size={props?.size === "small" ? "small" : "medium"}
          onClick={() => {
            const val = (props.value || "").trim();
            if (val && props.onSubmit) {
              props.onSubmit(props.value);
            }
          }}
          disabled={!((props.value || "").trim())}
          sx={{
            color: "action.active",
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
            p: props?.size === "small" ? 0.75 : 1,
            minWidth: props?.size === "small" ? 36 : 44,
            flexShrink: 0,
            opacity: !((props.value || "").trim()) ? 0.4 : 1
          }}
        >
          <SearchIcon fontSize="medium" />
        </IconButton>
      </Box>
    );
  }

  return commonTextField;
}
